<template>
    <div class="banner-ribbon-wrapper">
        <div class="text-center banner-ribbon-text">
            <span>{{$t("ribbon_text_top")}}</span>
            <br>
            <span>{{$t("ribbon_text_bottom")}}</span>
        </div>
        <div class="banner-ribbon-tail">
            <div class="triangle-down-left">
                <span class="triangle-down-left-into"></span>
            </div>
            <div class="triangle-down-right"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "BannerRibbon",
        data() {
            return {
                isShowCoupon: true,
                isShowHomeVariant: false,
                isShowRibbon : true,
                isMoveTips : false
            }
        },
        created() {},
        mounted() {},
        methods: {}
    }
</script>
<style>
    .banner-ribbon-text {
        font-family: SharpSansSimiBold;
        font-weight: 600;
        font-size: 16px;
        background-color: rgba(112, 0, 0, 1);
        color: #fff;
        padding-top: 16px;
        padding-bottom: 16px;
    }    
    .banner-ribbon-wrapper {
        -webkit-transform: translateY(30px) scale(1.21);
        margin-bottom: 10px;
    }
    .triangle-down-left {
        width: 0;
        height: 0;
        border-top: 23px solid #590000;
        border-left: 43px solid transparent;
        position: relative;
    }
    .triangle-down-right {
        width: 0;
        height: 0;
        border-top: 23px solid #590000;
        border-right: 43px solid transparent;
    }
    .triangle-down-right::after {
        content: "";
        width: 0;
        height: 0;
        border-top: 22px solid #3C0000;
        border-right: 20px solid transparent;
    }
    .triangle-down-left-into {
        position: absolute;
        width: 0;
        height: 0;
        top: -22px;
        left: -20px;
        border-top: 22px solid #3C0000;
        border-left: 20px solid transparent;
    }
    .banner-ribbon-tail {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    @media only screen and (max-width: 992px) {
        .banner-ribbon-wrapper {
            margin-bottom: 14px;
        }
        .banner-ribbon-text {
            font-size: 12px;
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .triangle-down-left {
            border-top: 19px solid #590000;
            border-left: 26px solid transparent;
        }
        .triangle-down-left-into{
            top: -18px;
            left: -15px;
            border-top: 18px solid #3C0000;
            border-left: 14px solid transparent;
        }
        .triangle-down-right {
            border-top: 19px solid #590000;
            border-right: 26px solid transparent;
        }
        .triangle-down-right::after {
            border-top: 18px solid #3C0000;
            border-right: 14px solid transparent;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/popup/BannerRibbon.vue